import { render, staticRenderFns } from "./vipFree.vue?vue&type=template&id=2e52da92&scoped=true&"
import script from "./vipFree.vue?vue&type=script&lang=ts&"
export * from "./vipFree.vue?vue&type=script&lang=ts&"
import style0 from "./vipFree.vue?vue&type=style&index=0&id=2e52da92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52da92",
  null
  
)

export default component.exports